import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-showcase',
  templateUrl: './ui-showcase.component.html',
  styleUrls: ['./ui-showcase.component.scss']
})
export class UiShowcaseComponent { }
